module.exports = __webpack_public_path__ + "static/opc2-b143733acac4ae882486f7c33a561432.png";